// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-error[data-v-6d911981] {\r\n  color: red;\n}\r\n", ""]);
// Exports
module.exports = exports;
